import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import GetUserInfoService from "../../../../service/GetUserInfoService";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "../StatementTable/StatementTable.css";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";
import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import AssignAttributes from "../AssignAttributes/AssignAttributes";
import ProductService from "../../../../service/ProductService";
import { FileUpload } from "primereact/fileupload";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Tooltip } from "primereact/tooltip";
import { InputNumber } from "primereact/inputnumber";
import "./ProductsList.css";
import EditingProduct from "../EditingProduct/EditingProduct";
import handleCurrency from "../../../../utilities/CurrencySwitch";
import DOMPurify from "dompurify";
import ReactQuill from "react-quill";
import { FilterMatchMode } from "primereact/api";
import { TabView } from "primereact/tabview";
import { TabPanel } from "primereact/tabview";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { locale } from "../../../../utilities/locale/locale";
import { localeISO } from "../../../../utilities/localeIso";
import { formatPrice } from "../../../../utilities/formatPrice";
import { PLATFORM_PRODUCT_FEE } from "../../../../utilities/constants";
import MinimalPrice from "../../../ProductInfo/components/MinimalPrice/MinimalPrice";
import PromotionalPrice from "../../../ProductInfo/components/ProductPromotionalPrice/ProductPromotionalPrice";
import ProductPrice from "../../../ProductInfo/components/ProductPrice/ProductPrice";

const SituationColumn = ({ status }) => {
  return (
    <div style={{ minWidth: "120px" }}>
      {status === "PUBLISHED" ? (
        <span
          className="team-member-role text-0 p-1 border-round block text-center"
          style={{ backgroundColor: "#46a748" }}
        >
          {localeText("published")}
        </span>
      ) : status === "UNPUBLISHED" ? (
        <span
          className="team-member-role text-0 p-1 border-round block text-center"
          style={{ backgroundColor: "#eb4034" }}
        >
          {localeText("unpublished")}
        </span>
      ) : (
        <span
          className="team-member-role text-0 p-1 border-round block text-center"
          style={{ backgroundColor: "#607D8B" }}
        >
          {localeText("archivedProduct")}
        </span>
      )}
    </div>
  );
};

const VisibilityColumn = ({ status, onClickPublished, onClickUnpublished }) => {
  return (
    <div>
      {status === "PUBLISHED" ? (
        <Button
          icon="pi pi-eye-slash"
          onClick={onClickUnpublished}
          className="p-button-danger p-button-rounded"
          style={{ fontSize: "1rem", width: "100%", minWidth: "150px" }}
          label={localeText("unpublish")}
        />
      ) : status === "DELETED" ? (
        <div className="flex gap-2">
          <Button
            icon="pi pi-eye-slash"
            onClick={onClickUnpublished}
            className="p-button-danger p-button-rounded"
            style={{ fontSize: "1rem", width: "100%", minWidth: "150px" }}
            label={localeText("unpublish")}
          />
          <Button
            icon="pi pi-upload"
            onClick={onClickPublished}
            className="p-button-success p-button-rounded"
            style={{ fontSize: "1rem", width: "100%", minWidth: "150px" }}
            label={localeText("publish")}
          />
        </div>
      ) : (
        <Button
          icon="pi pi-upload"
          onClick={onClickPublished}
          className="p-button-success p-button-rounded"
          style={{ fontSize: "1rem", width: "100%", minWidth: "150px" }}
          label={localeText("publish")}
        />
      )}
    </div>
  );
};

const ProductsList = (props) => {
  const getUserInfoService = new GetUserInfoService();
  const productService = new ProductService();
  const [products, setProducts] = useState([]);
  const [retryFetchProducts, setRetryFetchProducts] = useState(false);
  const toast = useRef(null);
  const fileUploadRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isLoadingUnassignattribute, setIsLoadingUnassignattribute] = useState(false);
  const [loadingProduct, setLoadingProduct] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [assigningProduct, setAssigningProduct] = useState(null);
  const [editingVariation, setEditingVariation] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [imagesVariation, setImagesVariation] = useState([]);
  const [priceVariation, setPriceVariation] = useState(0);
  const [stockVariation, setStockVariation] = useState(0);
  const [variationImage, setVariationImage] = useState(null);
  const [changingVariationImage, setChangingVariationImage] = useState(false);
  const [deletingVariation, setDeletingVariation] = useState(null);
  const [deletingVisible, setDeletingVisible] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [previewingProduct, setPreviewingProduct] = useState(null);
  const [currentVariation, setCurrentVariation] = useState(null);
  const [attribute1Values, setAttribute1Values] = useState([]);
  const [attribute2Values, setAttribute2Values] = useState([]);
  const [currentAttribute1Value, setCurrentAttribute1Value] = useState(null);
  const [currentAttribute2Value, setCurrentAttribute2Value] = useState(null);
  const [currency, setCurrency] = useState("");
  const [editingProductObj, setEditingProductObj] = useState(null);
  const [technicalInfo, setTechnicalInfo] = useState([]);

  const filters2 = {
    title: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  const [tableIndex, setTableIndex] = useState(0);
  const [publishedProducts, setPublishedProducts] = useState([]);
  const [unpublishedProducts, setUnpublishedProducts] = useState([]);
  const [importedProducts, setImportedProducts] = useState([]);
  const [archivedProducts, setArchivedProducts] = useState([]);

  const uploadOptions = {
    className: "hidden",
  };

  const handleUnassignattribute = ({ idattribute, idproduct }) => {
    setIsLoadingUnassignattribute(true);
    productService
      .postUnassignAttribute(idattribute, idproduct)
      .then(() => {
        setAssigningProduct((prev) => {
          return {
            ...prev,
            attributes: prev.attributes.filter((attribute) => attribute.id !== idattribute),
          };
        });
      })
      .finally(() => {
        setRetryFetchProducts(true);
        setIsLoadingUnassignattribute(false);
      });
  };

  async function FetchProducts(cancel) {
    try {
      setLoading(true);

      const res = await getUserInfoService.getProducts(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );
      if (cancel) return;

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });

        setLoading(false);
      } else {
        setLoading(false);

        setProducts(res.result.filter((product) => product.status !== "DELETED"));
        setPublishedProducts(res.result.filter((product) => product.status === "PUBLISHED"));
        setUnpublishedProducts(res.result.filter((product) => product.status === "UNPUBLISHED"));
        setImportedProducts(res.result.filter((product) => product.originProductImported));
        setArchivedProducts(res.result.filter((product) => product.status === "DELETED"));

        if (props.imported === "true") setTableIndex(3);
      }
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    let cancel = false;

    FetchProducts(cancel);

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let cancel = false;

    if (retryFetchProducts) {
      FetchProducts(cancel);
      setRetryFetchProducts(false);
    }

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retryFetchProducts]);

  async function getProductById(id, previewing) {
    try {
      if (previewing) setLoadingPreview(true);
      else setLoadingProduct(true);

      const res = await productService.getProductById(id);

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });

        if (previewing) setLoadingPreview(false);
        else setLoadingProduct(false);
      } else {
        if (previewing) {
          const arrImg = [];

          if (res.result.product.imageid1) arrImg.push(res.result.product.imageid1);
          if (res.result.product.imageid2) arrImg.push(res.result.product.imageid2);
          if (res.result.product.imageid3) arrImg.push(res.result.product.imageid3);
          if (res.result.product.imageid4) arrImg.push(res.result.product.imageid4);
          if (res.result.product.imageid5) arrImg.push(res.result.product.imageid5);

          setImages(arrImg);
          setPreviewingProduct(res.result);

          if (res.result.productVariations.length > 0) {
            const imgsVariation = [];

            res.result.productVariations.forEach((variation) => {
              if (variation.imageid) imgsVariation.push(variation.imageid);
            });

            setImagesVariation(imgsVariation);
          }

          const resTechInfo = await productService.getTechnicalInfo(res.result.product.id);

          if (resTechInfo.messageCode !== 200001) {
            toast.current.show({
              severity: "error",
              summary: localeText("error"),
              detail: localeText("data").find((msg) => msg.code === resTechInfo.messageCode)
                .message,
              life: 6000,
            });
            if (resTechInfo.messageCode === 500000) console.log(resTechInfo);
          } else setTechnicalInfo(resTechInfo.result);
        } else setAssigningProduct(res.result);

        if (previewing) setLoadingPreview(false);
        else setLoadingProduct(false);
      }
    } catch (e) {
      if (previewing) setLoadingPreview(false);
      else setLoadingProduct(false);
      console.log(e);
    }
  }

  async function generateVariations() {
    try {
      setLoading(true);

      const res = await productService.postCreateVariations(
        localStorage.getItem("__extraconomy_token"),
        assigningProduct.product.id,
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoading(false);
      } else {
        const resProductId = await productService.getProductById(assigningProduct.product.id);

        if (resProductId.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resProductId.messageCode).message,
            life: 6000,
          });
          setLoading(false);
          return;
        } else {
          setAssigningProduct(resProductId.result);
          setLoading(false);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function deleteVariation(variation) {
    try {
      setLoadingDelete(true);

      const res = await productService.deleteVariation(
        localStorage.getItem("__extraconomy_token"),
        variation.id,
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200003) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingDelete(false);
      } else {
        const resProductId = await productService.getProductById(assigningProduct.product.id);

        if (resProductId.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resProductId.messageCode).message,
            life: 6000,
          });
          setLoadingDelete(false);
          return;
        } else {
          toast.current.show({
            severity: "info",
            summary: localeText("success"),
            detail: localeText("variationDeletedSuccessfully"),
            life: 6000,
          });
          setAssigningProduct(resProductId.result);
          setLoadingDelete(false);
        }
      }
    } catch (e) {
      console.log(e);
      setLoadingDelete(false);
    }
  }

  useEffect(() => {
    if (assigningProduct) {
      const imgArr = [];

      if (assigningProduct.product.imageid1) imgArr.push(assigningProduct.product.imageid1);
      if (assigningProduct.product.imageid2) imgArr.push(assigningProduct.product.imageid2);
      if (assigningProduct.product.imageid3) imgArr.push(assigningProduct.product.imageid3);
      if (assigningProduct.product.imageid4) imgArr.push(assigningProduct.product.imageid4);
      if (assigningProduct.product.imageid5) imgArr.push(assigningProduct.product.imageid5);

      setImages(imgArr);

      if (assigningProduct.product.currency)
        setCurrency(handleCurrency(assigningProduct.product.currency));
    }
  }, [assigningProduct]);

  async function confirmVariationChanges() {
    try {
      if (priceVariation <= 0) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("variationMustHaveAValidPrice"),
          life: 6000,
        });
        setLoading(false);
        return;
      }

      setLoading(true);
      let imageId = null;
      let error = false;

      if (variationImage && typeof variationImage !== "string") {
        imageId = await uploadImages(variationImage);

        const resImg = await productService.postSetImageByVariation(
          localStorage.getItem("__extraconomy_token"),
          editingVariation.id,
          imageId,
          localStorage.getItem("__extraconomy_username")
        );

        if (resImg.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resImg.messageCode).message,
            life: 6000,
          });
          error = true;
          setLoading(false);
        }
      }

      const resPrice = await productService.postSetPriceByVariation(
        localStorage.getItem("__extraconomy_token"),
        editingVariation.id,
        priceVariation,
        localStorage.getItem("__extraconomy_username")
      );

      if (resPrice.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === resPrice.messageCode).message,
          life: 6000,
        });
        error = true;
        setLoading(false);
      }

      const resStock = await productService.postSetStockByVariation(
        localStorage.getItem("__extraconomy_token"),
        editingVariation.id,
        assigningProduct.product.id,
        stockVariation,
        localStorage.getItem("__extraconomy_username")
      );

      if (resStock.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === resStock.messageCode).message,
          life: 6000,
        });
        error = true;
        setLoading(false);
      }

      if (!error) {
        setChangingVariationImage(false);

        const resProduct = await productService.getProductById(assigningProduct.product.id);

        if (resProduct.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resProduct.messageCode).message,
            life: 6000,
          });
          setLoading(false);
        } else {
          setLoading(false);
          setAssigningProduct(resProduct.result);
          toast.current.show({
            severity: "success",
            summary: localeText("success"),
            detail: localeText("variationUpdatedSuccessfully"),
            life: 6000,
          });

          if (variationImage && typeof variationImage !== "string") {
            setEditingVariation(
              resProduct.result.productVariations.find(
                (variation) => variation.id === editingVariation.id
              )
            );

            setCurrentImageIndex(-1);

            const deselectedImageElem = document.getElementById(`pi${currentImageIndex}`);
            deselectedImageElem.style.backgroundColor = "initial";
            deselectedImageElem.style.border = "1px solid #E0E0E0";

            const imageElem = document.getElementById(`pi${images.length}`);
            imageElem.style.backgroundColor = "#272360";
            imageElem.style.border = "1px solid #272360";
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function uploadImages(image) {
    try {
      const res = await productService.postUploadImage(
        localStorage.getItem("__extraconomy_token"),
        image
      );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        return false;
      } else return res.result;
    } catch (e) {
      if (e.status === 401) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      } else if (e.status === 500) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedSystemBehaviour"),
          life: 6000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedErrorUploadImg"),
          life: 6000,
        });
      }
    }
  }

  useEffect(() => {
    if (editingVariation) {
      setPriceVariation(editingVariation.price);
      setStockVariation(editingVariation.amountInStock);

      if (editingVariation.imageid) {
        setCurrentImageIndex(-1);
        setVariationImage(editingVariation.imageid);

        const imageElem = document.getElementById(`pi${images.length}`);
        imageElem.style.backgroundColor = "#272360";
        imageElem.style.border = "1px solid #272360";
      } else {
        setCurrentImageIndex(0);

        const imageElem = document.getElementById("pi0");
        imageElem.style.backgroundColor = "#272360";
        imageElem.style.border = "1px solid #272360";
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingVariation]);

  useEffect(() => {
    if (currentVariation) {
      if (currentVariation.imageid) {
        const deselectedImageElem = document.getElementById(`pi${currentImageIndex}`);
        deselectedImageElem.style.backgroundColor = "initial";
        deselectedImageElem.style.border = "1px solid #E0E0E0";

        const indexOfImage = imagesVariation.findIndex(
          (image) => image === currentVariation.imageid
        );

        const imageElem = document.getElementById(`pi${indexOfImage + 5}`);
        imageElem.style.backgroundColor = "#272360";
        imageElem.style.border = "1px solid #272360";

        setCurrentImageIndex(indexOfImage + 5);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentVariation]);

  useEffect(() => {
    let cancel = false;

    setCurrentVariation(null);
    setAttribute1Values([]);
    setAttribute2Values([]);
    setCurrentAttribute1Value(null);
    setCurrentAttribute2Value(null);

    async function fetchAttributes() {
      if (previewingProduct && previewingProduct.productVariations.length > 0) {
        for (let i = 0; i < previewingProduct.attributes.length; i++) {
          setLoading(true);

          const res = await productService.getAttributeValues(
            localStorage.getItem("__extraconomy_token"),
            previewingProduct.attributes[i].id,
            localStorage.getItem("__extraconomy_username")
          );

          if (cancel) return;

          if (res.messageCode !== 200001) {
            toast.current.show({
              severity: "error",
              summary: localeText("error"),
              detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
              life: 6000,
            });
            setLoading(false);
          } else {
            setCurrentImageIndex(0);
            if (i === 0) setAttribute1Values(res.result);
            else setAttribute2Values(res.result);

            const imageElem = document.getElementById(`pi0`);
            imageElem.style.backgroundColor = "#272360";
            imageElem.style.border = "1px solid #272360";

            setLoading(false);
          }
        }
      } else {
        setCurrentImageIndex(0);
      }
    }

    fetchAttributes();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewingProduct]);

  useEffect(() => {
    if (previewingProduct) setCurrency(handleCurrency(previewingProduct.product.currency));
  }, [previewingProduct]);

  function checkAndSetCurrentAttribute1Value(elem, value) {
    if (!elem.target.classList.contains("bg-disabled")) {
      setCurrentAttribute1Value(value);

      if (previewingProduct.attributes.length === 2) {
        attribute2Values.forEach((value2) => {
          const variationFind = previewingProduct.productVariations.find(
            (variation) =>
              variation.attribute1.id === value.id && variation.attribute2.id === value2.id
          );

          if (!variationFind || (variationFind && !variationFind.imageid)) {
            const elemAttribute2 = document.getElementById(`at${value2.id}`);
            elemAttribute2.classList.remove("bg-primary");
            elemAttribute2.classList.remove("cursor-pointer");
            elemAttribute2.classList.add("bg-disabled");
          } else {
            const elemAttribute2 = document.getElementById(`at${value2.id}`);
            if (!elemAttribute2.classList.contains("bg-primary"))
              elemAttribute2.classList.add("bg-primary");
            if (!elemAttribute2.classList.contains("cursor-pointer"))
              elemAttribute2.classList.add("cursor-pointer");
            if (elemAttribute2.classList.contains("bg-disabled"))
              elemAttribute2.classList.remove("bg-disabled");
          }
        });

        if (currentAttribute2Value) {
          const elemAttribute2Real = document.getElementById(`at${currentAttribute2Value.id}`);
          if (!elemAttribute2Real.classList.contains("bg-disabled")) {
            const variationFind = previewingProduct.productVariations.find(
              (variation) =>
                variation.attribute1.id === value.id &&
                variation.attribute2.id === currentAttribute2Value.id
            );

            if (variationFind) setCurrentVariation(variationFind);
          } else {
            setCurrentAttribute2Value(null);
          }
        }
      } else {
        setCurrentVariation(
          previewingProduct.productVariations.find(
            (variation) => variation.attribute1.id === value.id
          )
        );
      }
    }
  }

  function checkAndSetCurrentAttribute2Value(elem, value) {
    if (!elem.target.classList.contains("bg-disabled")) {
      setCurrentAttribute2Value(value);

      attribute1Values.forEach((value1) => {
        const variationFind = previewingProduct.productVariations.find(
          (variation) =>
            variation.attribute1.id === value1.id && variation.attribute2.id === value.id
        );

        if (!variationFind || (variationFind && !variationFind.imageid)) {
          const elemAttribute1 = document.getElementById(`at${value1.id}`);
          elemAttribute1.classList.remove("bg-primary");
          elemAttribute1.classList.remove("cursor-pointer");
          elemAttribute1.classList.add("bg-disabled");
        } else {
          const elemAttribute1 = document.getElementById(`at${value1.id}`);
          if (!elemAttribute1.classList.contains("bg-primary"))
            elemAttribute1.classList.add("bg-primary");
          if (!elemAttribute1.classList.contains("cursor-pointer"))
            elemAttribute1.classList.add("cursor-pointer");
          if (elemAttribute1.classList.contains("bg-disabled"))
            elemAttribute1.classList.remove("bg-disabled");
        }
      });

      if (currentAttribute1Value) {
        const elemAttribute1Real = document.getElementById(`at${currentAttribute1Value.id}`);
        if (!elemAttribute1Real.classList.contains("bg-disabled")) {
          const variationFind = previewingProduct.productVariations.find(
            (variation) =>
              variation.attribute1.id === currentAttribute1Value.id &&
              variation.attribute2.id === value.id
          );

          if (variationFind) setCurrentVariation(variationFind);
        } else {
          setCurrentAttribute1Value(null);
        }
      }
    }
  }

  useEffect(() => {
    if (currentAttribute1Value && previewingProduct.attributes.length === 1) {
      const variationFind = previewingProduct.productVariations.find(
        (variation) => variation.attribute1.id === currentAttribute1Value.id
      );

      if (!variationFind || (variationFind && !variationFind.imageid)) {
        const attributeElem = document.getElementById(`at${currentAttribute1Value.id}`);
        attributeElem.classList.remove("bg-primary");
        attributeElem.classList.add("bg-disabled");

        setCurrentAttribute1Value(null);
        setCurrentVariation(null);

        const deselectedImageElem = document.getElementById(`pi${currentImageIndex}`);
        deselectedImageElem.style.backgroundColor = "initial";
        deselectedImageElem.style.border = "1px solid #E0E0E0";

        const image0Elem = document.getElementById(`pi0`);
        image0Elem.style.border = "1px solid #272360";
        image0Elem.style.background = "#272360";

        setCurrentImageIndex(0);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAttribute1Value]);

  async function modifyStatus(id, status) {
    try {
      setLoading(true);

      const res = await productService.postModifyStatus(
        localStorage.getItem("__extraconomy_token"),
        id,
        status,
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoading(false);
      } else {
        toast.current.show({
          severity: status === "PUBLISHED" ? "success" : "info",
          summary: status === "PUBLISHED" ? localeText("success") : localeText("info"),
          detail:
            status === "PUBLISHED"
              ? localeText("productPublishedSuccessfully")
              : localeText("productUnpublishedSuccessfully"),
          life: 6000,
        });

        const resProducts = await getUserInfoService.getProducts(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username")
        );

        if (resProducts.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resProducts.messageCode).message,
            life: 6000,
          });
          setLoading(false);
        } else {
          setProducts(resProducts.result.filter((product) => product.status !== "DELETED"));
          setPublishedProducts(
            resProducts.result.filter((product) => product.status === "PUBLISHED")
          );
          setUnpublishedProducts(
            resProducts.result.filter((product) => product.status === "UNPUBLISHED")
          );
          setArchivedProducts(resProducts.result.filter((product) => product.status === "DELETED"));
        }

        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }

  async function editingProduct(id) {
    try {
      setLoading(true);

      const res = await productService.getProductById(id);

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        setLoading(false);
      } else {
        setEditingProductObj(res.result);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <div>
      <Toast ref={toast} />
      <div className="fixed bottom-0 right-0 z-5 mr-2" style={{ marginBottom: "90px" }}>
        <Button
          icon="pi pi-arrow-up"
          className="p-button p-button-rounded p-button-secondary"
          onClick={() => window.scrollTo(0, 0)}
        />
      </div>
      <div className="card border-1 border-300">
        <div>
          <Link to="/shop">
            <Button
              className="mt-2 mb-2 ml-2"
              icon="pi pi-shopping-cart"
              label={localeText("shop")}
            />
          </Link>
        </div>
        {props.plan !== "Promoter" && (
          <>
            {!editingProductObj ? (
              <>
                {assigningProduct && (
                  <>
                    {!editingVariation ? (
                      <Button
                        icon="pi pi-arrow-left"
                        onClick={() => setAssigningProduct(null)}
                        label={localeText("goBackProductList")}
                        className="my-4"
                      />
                    ) : (
                      <Button
                        icon="pi pi-arrow-left"
                        onClick={() => {
                          setChangingVariationImage(false);
                          setEditingVariation(false);
                        }}
                        label={localeText("goBackToVariationsList")}
                        className="my-4"
                      />
                    )}

                    {assigningProduct.attributes.length === 0 ? (
                      <>
                        <AssignAttributes
                          plan={props.plan}
                          product={assigningProduct}
                          setAssigningProduct={setAssigningProduct}
                        />
                      </>
                    ) : (
                      <div>
                        <div className="flex align-items-center">
                          <AdvancedImage
                            cldImg={cloudinaryInstance
                              .image(assigningProduct.product.imageid1)
                              .format("webp")
                              .resize(fill().width(600).height(600))}
                            height={75}
                            style={{ border: "1px solid #E0E0E0" }}
                            className="border-round"
                          />
                          <i className="pi pi-angle-right text-4xl text-400 ml-2"></i>
                          <h3 className="my-4 ml-1">
                            {localeText("manageVariations")} "{assigningProduct.product.title}"
                          </h3>
                        </div>
                        <hr />
                        {assigningProduct.productVariations.length === 0 ? (
                          <div className="text-center">
                            {loading || isLoadingUnassignattribute ? (
                              <>
                                <div className="text-center">
                                  <i className="pi pi-spin pi-spinner text-8xl text-500 my-8"></i>
                                </div>
                              </>
                            ) : (
                              <>
                                <i className="pi pi-search text-7xl my-6 text-400"></i>
                                <p>{localeText("noVariations")}</p>
                                <h5 className="mt-6">{localeText("theValuesOfTheseAttributes")}</h5>
                                <div className="flex justify-content-center my-4">
                                  {assigningProduct.attributes.map((attribute) => {
                                    return (
                                      <div key={attribute.id} className="relative">
                                        <div
                                          onClick={() => {
                                            handleUnassignattribute({
                                              idattribute: attribute.id,
                                              idproduct: assigningProduct.product.id,
                                            });
                                          }}
                                          className="absolute cursor-pointer"
                                          style={{
                                            backgroundColor: "red",
                                            borderRadius: "100%",
                                            top: "-12px",
                                            right: "-5px",
                                            padding: "1px 5px",
                                          }}
                                        >
                                          <i className="pi pi-times text-xs text-400 text-white" />
                                        </div>
                                        <Link to="/attributes">
                                          <div
                                            className="bg-primary mx-1 text-0 p-2 flex justify-content-center align-items-center"
                                            style={{ borderRadius: ".5em" }}
                                          >
                                            {attribute.attribute}
                                          </div>
                                        </Link>
                                      </div>
                                    );
                                  })}
                                </div>
                                <Button
                                  label={localeText("generateVariations")}
                                  className="mt-4 mb-6 p-button-success"
                                  onClick={() => generateVariations()}
                                />
                              </>
                            )}
                          </div>
                        ) : (
                          <div>
                            {!editingVariation ? (
                              <>
                                <ConfirmDialog
                                  visible={deletingVisible}
                                  onHide={() => setDeletingVisible(false)}
                                  message={localeText("deleteThisVariation")}
                                  header={localeText("confirmYourAction")}
                                  icon="pi pi-exclamation-triangle"
                                  accept={() => deleteVariation(deletingVariation)}
                                  reject={() => setDeletingVisible(false)}
                                  acceptLabel={localeText("confirm")}
                                  rejectLabel={localeText("cancel")}
                                />

                                <DataTable
                                  value={assigningProduct.productVariations}
                                  paginator
                                  responsiveLayout="scroll"
                                  className="mt-4 mb-6"
                                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                  currentPageReportTemplate={localeText("showingFirstToLast")}
                                  rows={10}
                                  rowsPerPageOptions={[10, 20, 50]}
                                >
                                  <Column
                                    header={localeText("attributes")}
                                    body={(variation) => {
                                      return (
                                        <div className="flex">
                                          <div
                                            className="bg-primary text-0 p-2 flex justify-content-center align-items-center"
                                            style={{ borderRadius: ".5em" }}
                                          >
                                            {variation.attribute1.attributeValue}
                                          </div>
                                          {variation.attribute2 && (
                                            <div
                                              className="ml-2 bg-primary text-0 p-2 flex justify-content-center align-items-center"
                                              style={{ borderRadius: ".5em" }}
                                            >
                                              {variation.attribute2.attributeValue}
                                            </div>
                                          )}
                                        </div>
                                      );
                                    }}
                                  />
                                  <Column
                                    header={localeText("image")}
                                    body={(variation) => {
                                      return (
                                        <div>
                                          {variation.imageid ? (
                                            <AdvancedImage
                                              cldImg={cloudinaryInstance
                                                .image(variation.imageid)
                                                .format("webp")
                                                .resize(fill().width(600).height(600))}
                                              height={75}
                                              style={{ border: "1px solid #E0E0E0" }}
                                              className="border-round"
                                            />
                                          ) : (
                                            <AdvancedImage
                                              cldImg={cloudinaryInstance
                                                .image(assigningProduct.product.imageid1)
                                                .format("webp")
                                                .resize(fill().width(600).height(600))}
                                              height={75}
                                              style={{ border: "1px solid #E0E0E0" }}
                                              className="border-round"
                                            />
                                          )}
                                        </div>
                                      );
                                    }}
                                  />
                                  <Column field="amountInStock" header={localeText("stock")} />
                                  <Column
                                    header={localeText("price")}
                                    body={(variation) => {
                                      const product = assigningProduct.product;
                                      const currentCurrency = product.currency;
                                      const variationPrice =
                                        variation.price + variation.price * PLATFORM_PRODUCT_FEE;

                                      const variationFinalPrice =
                                        product?.shippingOption === "FREESENDCLOUD"
                                          ? variationPrice + product?.shippingPrice ?? 0
                                          : variationPrice;

                                      return (
                                        <>
                                          {currentCurrency} {formatPrice(variationFinalPrice)}
                                        </>
                                      );
                                    }}
                                  />
                                  <Column
                                    header={localeText("delete")}
                                    body={(variation) => {
                                      return (
                                        <Button
                                          icon="pi pi-times"
                                          className="p-button-danger p-button-rounded"
                                          onClick={() => {
                                            setDeletingVariation(variation);
                                            setDeletingVisible(true);
                                          }}
                                          loading={loadingDelete}
                                        />
                                      );
                                    }}
                                  />
                                  <Column
                                    header={localeText("edit")}
                                    body={(variation) => {
                                      return (
                                        <Button
                                          icon="pi pi-pencil"
                                          className="p-button p-button-rounded"
                                          onClick={() => setEditingVariation(variation)}
                                        />
                                      );
                                    }}
                                  />
                                </DataTable>
                              </>
                            ) : (
                              <div>
                                <div className="mt-6">
                                  {locale === "en" && (
                                    <span className="text-600">
                                      {assigningProduct.product.subCategory.descriptionEnglish}
                                    </span>
                                  )}
                                  {locale === "it" && (
                                    <span className="text-600">
                                      {assigningProduct.product.subCategory.descriptionItalian}
                                    </span>
                                  )}
                                  {locale === "pt" && (
                                    <span className="text-600">
                                      {assigningProduct.product.subCategory.descriptionPortuguese}
                                    </span>
                                  )}
                                  {locale === "es" && (
                                    <span className="text-600">
                                      {assigningProduct.product.subCategory.descriptionSpanish}
                                    </span>
                                  )}
                                </div>

                                <div className="lg:flex mx-0 mt-4">
                                  <div className="lg:mr-2">
                                    <ul className="my-0 p-0 list-none flex lg:block md:flex justify-content-center">
                                      {images.map((image, index) => {
                                        return (
                                          <div key={`img${index}`}>
                                            <li
                                              className="flex justify-content-end mb-4 lg:mb-2 mx-1 lg:mx-0"
                                              onClick={() => {
                                                if (currentImageIndex >= 0) {
                                                  const deselectedImageElem =
                                                    document.getElementById(
                                                      `pi${currentImageIndex}`
                                                    );
                                                  deselectedImageElem.style.backgroundColor =
                                                    "initial";
                                                  deselectedImageElem.style.border =
                                                    "1px solid #E0E0E0";
                                                } else {
                                                  const deselectedImageElem =
                                                    document.getElementById(`pi${images.length}`);
                                                  deselectedImageElem.style.backgroundColor =
                                                    "initial";
                                                  deselectedImageElem.style.border =
                                                    "1px solid #E0E0E0";
                                                }

                                                const imageElem = document.getElementById(
                                                  `pi${index}`
                                                );
                                                imageElem.style.backgroundColor = "#272360";
                                                imageElem.style.border = "1px solid #272360";

                                                setCurrentImageIndex(index);
                                              }}
                                            >
                                              <div
                                                style={{ border: "1px solid #E0E0E0" }}
                                                className="border-round p-2 product-thumbnail"
                                                id={`pi${index}`}
                                              >
                                                <AdvancedImage
                                                  cldImg={cloudinaryInstance
                                                    .image(image)
                                                    .format("webp")
                                                    .resize(fill().width(600).height(600))}
                                                  height={50}
                                                />
                                              </div>
                                            </li>
                                          </div>
                                        );
                                      })}
                                      {editingVariation.imageid ? (
                                        <li
                                          className="flex justify-content-end mb-4 lg:mb-2 mx-1 lg:mx-0"
                                          onClick={() => {
                                            const deselectedImageElem = document.getElementById(
                                              `pi${currentImageIndex}`
                                            );
                                            deselectedImageElem.style.backgroundColor = "initial";
                                            deselectedImageElem.style.border = "1px solid #E0E0E0";

                                            const imageElem = document.getElementById(
                                              `pi${images.length}`
                                            );
                                            imageElem.style.backgroundColor = "#272360";
                                            imageElem.style.border = "1px solid #272360";

                                            setCurrentImageIndex(-1);
                                          }}
                                        >
                                          <div
                                            style={{ border: "1px solid #E0E0E0" }}
                                            className="border-round p-2 product-thumbnail"
                                            id={`pi${images.length}`}
                                          >
                                            {!variationImage ||
                                            typeof variationImage === "string" ? (
                                              <AdvancedImage
                                                cldImg={cloudinaryInstance
                                                  .image(editingVariation.imageid)
                                                  .format("webp")
                                                  .resize(fill().width(600).height(600))}
                                                height={50}
                                              />
                                            ) : (
                                              <div
                                                className="bg-center bg-cover"
                                                style={{
                                                  height: "50px",
                                                  width: "50px",
                                                  background: `url(${variationImage.objectURL})`,
                                                }}
                                              ></div>
                                            )}
                                          </div>
                                        </li>
                                      ) : (
                                        <li className="flex justify-content-end mb-4 lg:mb-2 mx-1 lg:mx-0">
                                          <div
                                            className="add-variation-img border-2 border-600 border-round border-dashed flex align-items-center justify-content-center cursor-pointer"
                                            style={{ height: "65px", width: "65px" }}
                                            onClick={() => setChangingVariationImage(true)}
                                          >
                                            <i className="pi pi-plus text-2xl text-600"></i>
                                          </div>
                                        </li>
                                      )}
                                    </ul>
                                  </div>

                                  <div className="outerDiv">
                                    {changingVariationImage ? (
                                      <>
                                        <FileUpload
                                          uploadOptions={uploadOptions}
                                          chooseLabel={localeText("choose")}
                                          cancelLabel={localeText("cancel")}
                                          name="demo"
                                          onSelect={(e) => {
                                            if (e.files[0].size / 1024 / 1024 > 5) {
                                              fileUploadRef.current.clear();
                                              toast.current.show({
                                                severity: "error",
                                                summary: localeText("error"),
                                                detail: localeText("fileSizeTooBig"),
                                                life: 6000,
                                              });
                                              return false;
                                            }

                                            setVariationImage(e.files[0]);
                                          }}
                                          onClear={() => setVariationImage(null)}
                                          onRemove={() => {
                                            fileUploadRef.current.clear();
                                            setVariationImage(null);
                                          }}
                                          onError={() => {
                                            fileUploadRef.current.clear();
                                            setVariationImage(null);
                                          }}
                                          onValidationFail={() => {
                                            fileUploadRef.current.clear();
                                            setVariationImage(null);
                                          }}
                                          accept="image/*"
                                          ref={fileUploadRef}
                                          emptyTemplate={
                                            <div className="text-center">
                                              <i
                                                className="pi pi-upload text-400"
                                                style={{ fontSize: "3em" }}
                                              ></i>
                                              <h3 className="text-400">
                                                {localeText("dragImgFile")}
                                              </h3>
                                            </div>
                                          }
                                          className="responsive-image h-auto"
                                        />

                                        <Button
                                          icon="pi pi-times"
                                          className="p-button-danger p-button-rounded mt-4"
                                          style={{ marginBottom: "40px" }}
                                          onClick={() => {
                                            setVariationImage(null);
                                            setChangingVariationImage(false);
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <div>
                                        <div className="flex align-items-center justify-content-center">
                                          {currentImageIndex === -1 && (
                                            <div
                                              className="flex justify-content-center align-items-center responsive-image absolute cursor-pointer product-thumbnail border-round"
                                              onClick={() => setChangingVariationImage(true)}
                                            >
                                              <i className="pi pi-pencil text-4xl bg-primary border-3 border-0 border-circle p-4"></i>
                                            </div>
                                          )}
                                          {currentImageIndex >= 0 ? (
                                            <AdvancedImage
                                              cldImg={cloudinaryInstance
                                                .image(images[currentImageIndex])
                                                .format("webp")
                                                .resize(fill().width(600).height(600))}
                                              className="border-round border-1 border-300 responsive-image"
                                            />
                                          ) : (
                                            <>
                                              {!variationImage ||
                                              typeof variationImage === "string" ? (
                                                <>
                                                  {editingVariation.imageid ? (
                                                    <AdvancedImage
                                                      cldImg={cloudinaryInstance
                                                        .image(editingVariation.imageid)
                                                        .format("webp")
                                                        .resize(fill().width(600).height(600))}
                                                      className="border-round border-1 border-300 responsive-image"
                                                    />
                                                  ) : (
                                                    <AdvancedImage
                                                      cldImg={cloudinaryInstance
                                                        .image(assigningProduct.product.imageid1)
                                                        .format("webp")
                                                        .resize(fill().width(600).height(600))}
                                                      className="border-round border-1 border-300 responsive-image"
                                                    />
                                                  )}
                                                </>
                                              ) : (
                                                <div
                                                  className="bg-center bg-cover border-round border-1 border-300 responsive-image"
                                                  style={{
                                                    background: `url(${variationImage.objectURL})`,
                                                  }}
                                                ></div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                        <p className="text-600 text-center mt-2 mb-4">
                                          {localeText("pressThePencilIconTo")}
                                        </p>
                                      </div>
                                    )}
                                  </div>

                                  <div className="lg:ml-4 md:ml-4 ml-0">
                                    <div className="flex align-items-center">
                                      <h1
                                        className="lg:text-5xl md:text-4xl text-3xl"
                                        style={{ marginTop: "12px" }}
                                      >
                                        <b>{assigningProduct.product.title}</b>
                                      </h1>
                                      {!assigningProduct.product.service &&
                                        !assigningProduct.product.downloadable && (
                                          <span
                                            style={{ backgroundColor: "#272360" }}
                                            className="text-0 p-1 text-xl border-round ml-2"
                                          >
                                            {assigningProduct.product.stateofproduct === "NEW" &&
                                              localeText("new").toUpperCase()}
                                            {assigningProduct.product.stateofproduct === "USED" &&
                                              localeText("used").toUpperCase()}
                                          </span>
                                        )}
                                    </div>

                                    <div className="mt-4">
                                      <ReactQuill
                                        className="react-quill-editor"
                                        value={DOMPurify.sanitize(
                                          assigningProduct.product.description
                                        )}
                                        readOnly
                                        theme="bubble"
                                      />
                                    </div>

                                    <div className="flex mt-4">
                                      <div
                                        className="bg-primary text-0 p-2 flex justify-content-center align-items-center"
                                        style={{ borderRadius: ".5em" }}
                                      >
                                        {editingVariation.attribute1.attributeValue}
                                      </div>
                                      {editingVariation.attribute2 && (
                                        <div
                                          className="ml-2 bg-primary text-0 p-2 flex justify-content-center align-items-center"
                                          style={{ borderRadius: ".5em" }}
                                        >
                                          {editingVariation.attribute2.attributeValue}
                                        </div>
                                      )}
                                    </div>

                                    {!assigningProduct.product.downloadable && (
                                      <h4 className="mt-6 flex align-items-center">
                                        <ul className="list-none p-0 m-0">
                                          <li>
                                            <b>{localeText("stock")}:</b>{" "}
                                          </li>
                                          <li>
                                            <InputNumber
                                              name="stock"
                                              value={editingVariation.amountInStock}
                                              onValueChange={(e) => setStockVariation(e.value)}
                                              className="mt-2"
                                            />
                                          </li>
                                        </ul>
                                      </h4>
                                    )}

                                    <h4 className="flex align-items-center">
                                      <ul className="list-none p-0 m-0">
                                        <li>
                                          <b>{localeText("price")}:</b>{" "}
                                        </li>
                                        <li>
                                          <InputNumber
                                            mode="currency"
                                            className="mt-2"
                                            currency={assigningProduct.product.currency}
                                            locale={localeISO}
                                            name="priceUnique"
                                            value={editingVariation.price}
                                            onChange={(e) => setPriceVariation(e.value)}
                                          />
                                        </li>
                                      </ul>
                                    </h4>

                                    <h4>
                                      <strong>
                                        {localeText("finalPrice")}:{" "}
                                        {assigningProduct.product.currency}{" "}
                                        {formatPrice(
                                          assigningProduct.product.shippingOption ===
                                            "FREESENDCLOUD"
                                            ? priceVariation +
                                                priceVariation * PLATFORM_PRODUCT_FEE +
                                                assigningProduct.product?.shippingPrice ?? 0
                                            : priceVariation + priceVariation * PLATFORM_PRODUCT_FEE
                                        )}
                                      </strong>
                                    </h4>

                                    <h4 className="text-lg mt-1">
                                      <strong>
                                        {localeText("platformFee")}(5%):{" "}
                                        {assigningProduct.product.currency}{" "}
                                        {formatPrice(priceVariation * PLATFORM_PRODUCT_FEE)}
                                      </strong>
                                    </h4>

                                    <h4 className="text-lg mt-1">
                                      <div className="flex align-items-center mb-4 flex-wrap">
                                        <b className="mr-1">Cashback:</b>
                                        <div className="flex align-items-start">
                                          <span
                                            className="font-light text-0 p-1 border-round"
                                            style={{ backgroundColor: "#f7b005" }}
                                          >
                                            {assigningProduct.product.currency}{" "}
                                            {formatPrice(
                                              priceVariation *
                                                (assigningProduct.product.percentExtraCoin / 100)
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </h4>

                                    <Button
                                      label={localeText("confirmChanges")}
                                      className="p-button mb-6"
                                      loading={loading}
                                      onClick={() => confirmVariationChanges()}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}

                {previewingProduct && (
                  <>
                    <Button
                      icon="pi pi-arrow-left"
                      onClick={() => setPreviewingProduct(null)}
                      label={localeText("goBackProductList")}
                      className="my-4"
                    />

                    <div className="flex align-items-center">
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(previewingProduct.product.imageid1)
                          .format("webp")
                          .resize(fill().width(600).height(600))}
                        height={75}
                        style={{ border: "1px solid #E0E0E0" }}
                        className="border-round"
                      />
                      <i className="pi pi-angle-right text-4xl text-400 ml-2"></i>
                      <h3 className="my-4">
                        {localeText("productPreview")} "{previewingProduct.product.title}"
                      </h3>
                    </div>
                    <hr />

                    <div className="mt-6">
                      {locale === "en" && (
                        <span className="text-600">
                          {previewingProduct.product.subCategory.descriptionEnglish}
                        </span>
                      )}
                      {locale === "it" && (
                        <span className="text-600">
                          {previewingProduct.product.subCategory.descriptionItalian}
                        </span>
                      )}
                      {locale === "pt" && (
                        <span className="text-600">
                          {previewingProduct.product.subCategory.descriptionPortuguese}
                        </span>
                      )}
                      {locale === "es" && (
                        <span className="text-600">
                          {previewingProduct.product.subCategory.descriptionSpanish}
                        </span>
                      )}
                    </div>

                    <div className="lg:flex mx-0 mt-4">
                      <div className="lg:mr-2">
                        <ul
                          className="my-0 p-0 list-none flex lg:block md:flex justify-content-center overflow-y-scroll"
                          style={{ maxHeight: "420px" }}
                        >
                          {images.map((image, index) => {
                            return (
                              <div key={`img${index}`}>
                                <li
                                  className="flex justify-content-end mb-4 lg:mb-2 mx-1 lg:mx-0"
                                  onClick={() => {
                                    const deselectedImageElem = document.getElementById(
                                      `pi${currentImageIndex}`
                                    );
                                    deselectedImageElem.style.backgroundColor = "initial";
                                    deselectedImageElem.style.border = "1px solid #E0E0E0";

                                    const imageElem = document.getElementById(`pi${index}`);
                                    imageElem.style.backgroundColor = "#272360";
                                    imageElem.style.border = "1px solid #272360";

                                    setCurrentImageIndex(index);
                                  }}
                                >
                                  <div
                                    style={{ border: "1px solid #E0E0E0" }}
                                    className="border-round p-2 product-thumbnail"
                                    id={`pi${index}`}
                                  >
                                    <AdvancedImage
                                      cldImg={cloudinaryInstance
                                        .image(image)
                                        .format("webp")
                                        .resize(fill().width(600).height(600))}
                                      height={50}
                                    />
                                  </div>
                                </li>
                              </div>
                            );
                          })}
                          <hr className="lg:block md:block hidden"></hr>
                          {imagesVariation.map((image, index) => {
                            return (
                              <div key={`img${index + 5}`}>
                                <li
                                  className="flex justify-content-end mb-4 lg:mb-2 mx-1 lg:mx-0"
                                  onClick={() => {
                                    const deselectedImageElem = document.getElementById(
                                      `pi${currentImageIndex}`
                                    );
                                    deselectedImageElem.style.backgroundColor = "initial";
                                    deselectedImageElem.style.border = "1px solid #E0E0E0";

                                    const imageElem = document.getElementById(`pi${index + 5}`);
                                    imageElem.style.backgroundColor = "#272360";
                                    imageElem.style.border = "1px solid #272360";

                                    setCurrentImageIndex(index + 5);
                                  }}
                                >
                                  <div
                                    style={{ border: "1px solid #E0E0E0" }}
                                    className="border-round p-2 product-thumbnail"
                                    id={`pi${index + 5}`}
                                  >
                                    <AdvancedImage
                                      cldImg={cloudinaryInstance
                                        .image(image)
                                        .format("webp")
                                        .resize(fill().width(600).height(600))}
                                      height={50}
                                    />
                                  </div>
                                </li>
                              </div>
                            );
                          })}
                        </ul>
                      </div>

                      <div className="outerDiv">
                        {currentImageIndex > 4 ? (
                          <AdvancedImage
                            cldImg={cloudinaryInstance
                              .image(imagesVariation[currentImageIndex - 5])
                              .format("webp")
                              .resize(fill().width(600).height(600))}
                            className="border-round border-1 border-300 responsive-image"
                          />
                        ) : (
                          <AdvancedImage
                            cldImg={cloudinaryInstance
                              .image(images[currentImageIndex])
                              .format("webp")
                              .resize(fill().width(600).height(600))}
                            className="border-round border-1 border-300 responsive-image"
                          />
                        )}
                      </div>

                      <div className="lg:ml-4 md:ml-4 ml-0">
                        <div className="flex align-items-center">
                          <h1
                            className="lg:text-5xl md:text-4xl text-3xl"
                            style={{ marginTop: "12px" }}
                          >
                            <b>{previewingProduct.product.title}</b>
                          </h1>
                          {!previewingProduct.product.downloadable &&
                          !previewingProduct.product.service ? (
                            <span
                              style={{
                                backgroundColor:
                                  previewingProduct.product.stateofproduct === "NEW"
                                    ? "#0288D1"
                                    : "#f7b005",
                              }}
                              className="text-0 p-1 text-xl border-round ml-2"
                            >
                              {previewingProduct.product.stateofproduct === "NEW" &&
                                localeText("new").toUpperCase()}
                              {previewingProduct.product.stateofproduct === "USED" &&
                                localeText("used").toUpperCase()}
                            </span>
                          ) : (
                            <div className="flex">
                              <i
                                className="pi pi-download text-0 p-2 text-xl border-circle ml-2"
                                style={{ backgroundColor: "#0288D1" }}
                              ></i>
                              <Tooltip target=".downloadable-tooltip" />
                              <i
                                className="pi pi-info-circle ml-1 downloadable-tooltip cursor-pointer text-600"
                                data-pr-tooltip={`${localeText("downloadableProductExplanation")}`}
                                data-pr-position="right"
                                data-pr-at="right+5 top"
                                data-pr-my="left center-2"
                                tooltipoptions={{ event: "focus" }}
                              ></i>
                            </div>
                          )}
                        </div>

                        <div className="mt-4">
                          <ReactQuill
                            className="react-quill-editor"
                            value={DOMPurify.sanitize(previewingProduct.product.description)}
                            readOnly
                            theme="bubble"
                          />
                        </div>

                        <div className="mb-4">
                          <ProductPrice
                            productInfo={{ data: previewingProduct }}
                            currency={currency}
                            currentVariation={currentVariation}
                            currentAttribute2Value={currentAttribute2Value}
                            currentAttribute1Value={currentAttribute1Value}
                          />

                          <PromotionalPrice
                            currency={currency}
                            productInfo={{ data: previewingProduct }}
                          />

                          <MinimalPrice
                            currency={currency}
                            currentVariation={currentVariation}
                            productInfo={{ data: previewingProduct }}
                          />
                        </div>

                        {previewingProduct.productVariations.length > 0 && (
                          <>
                            {loading ? (
                              <div className="ml-8">
                                <i className="pi pi-spin pi-spinner text-6xl text-500 my-4"></i>
                              </div>
                            ) : (
                              <>
                                {previewingProduct.productVariations.length > 0 && (
                                  <div className="mb-4">
                                    <div className="my-2">
                                      {previewingProduct.attributes[0].attribute}:<br></br>
                                    </div>
                                    <div className="flex align-items-center flex-wrap">
                                      {attribute1Values.map((value) => {
                                        return (
                                          <div key={value.id}>
                                            {currentAttribute1Value &&
                                            value.id === currentAttribute1Value.id ? (
                                              <div
                                                className="bg-primary text-0 p-2 flex justify-content-center align-items-center mx-2"
                                                style={{
                                                  borderRadius: ".5em",
                                                  outline: "2px solid #08790a",
                                                  outlineOffset: "2px",
                                                }}
                                                id={`at${value.id}`}
                                              >
                                                {value.attributeValue}
                                              </div>
                                            ) : (
                                              <div
                                                className="bg-primary text-0 p-2 flex justify-content-center align-items-center mx-2 cursor-pointer"
                                                style={{ borderRadius: ".5em" }}
                                                id={`at${value.id}`}
                                                onClick={(e) =>
                                                  checkAndSetCurrentAttribute1Value(e, value)
                                                }
                                              >
                                                {value.attributeValue}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })}
                                    </div>
                                    {previewingProduct.attributes[1] && (
                                      <>
                                        <div className="my-2">
                                          {previewingProduct.attributes[1].attribute}:<br></br>
                                        </div>
                                        <div className="flex align-items-center flex-wrap">
                                          {attribute2Values.map((value) => {
                                            return (
                                              <div key={value.id}>
                                                {currentAttribute2Value &&
                                                value.id === currentAttribute2Value.id ? (
                                                  <div
                                                    className="bg-primary text-0 p-2 flex justify-content-center align-items-center mx-2"
                                                    style={{
                                                      borderRadius: ".5em",
                                                      outline: "2px solid #08790a",
                                                      outlineOffset: "2px",
                                                    }}
                                                    id={`at${value.id}`}
                                                  >
                                                    {value.attributeValue}
                                                  </div>
                                                ) : (
                                                  <div
                                                    className="bg-primary text-0 p-2 flex justify-content-center align-items-center mx-2 cursor-pointer"
                                                    style={{ borderRadius: ".5em" }}
                                                    id={`at${value.id}`}
                                                    onClick={(e) =>
                                                      checkAndSetCurrentAttribute2Value(e, value)
                                                    }
                                                  >
                                                    {value.attributeValue}
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                )}
                              </>
                            )}
                          </>
                        )}

                        {!previewingProduct.product.downloadable ? (
                          <>
                            <p className="text-700">
                              {currentVariation &&
                              ((previewingProduct.attributes.length === 2 &&
                                currentAttribute1Value &&
                                currentAttribute2Value) ||
                                (previewingProduct.attributes.length === 1 &&
                                  currentAttribute1Value)) ? (
                                <>
                                  {currentVariation.amountInStock} {localeText("available")}
                                </>
                              ) : (
                                <>
                                  {previewingProduct.productVariations.length === 0 && (
                                    <>
                                      {previewingProduct.product.amountInStock}{" "}
                                      {localeText("available")}
                                    </>
                                  )}
                                </>
                              )}
                            </p>
                            <p className="text-700">
                              {localeText("shippingInfo")}:{" "}
                              {previewingProduct.product.sendBy === "SELLER" ? (
                                <>{localeText("bySeller")}</>
                              ) : (
                                <>{localeText("byBuyer")}</>
                              )}
                            </p>
                          </>
                        ) : (
                          <>
                            {!previewingProduct.product.service && (
                              <a
                                href={`${previewingProduct.product.urldownloadsample}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <h5 className="my-4">{localeText("clickForASample")}</h5>
                              </a>
                            )}
                          </>
                        )}

                        {!previewingProduct.product.downloadable ? (
                          <Button
                            label={
                              !currentVariation && previewingProduct.attributes.length === 1
                                ? `${localeText("selectOneAttribute")} "${
                                    previewingProduct.attributes[0].attribute
                                  }"`
                                : !currentVariation && previewingProduct.attributes.length === 2
                                ? `${localeText("selectTwoAttributes")} "${
                                    previewingProduct.attributes[0].attribute
                                  }" ${localeText("and")} "${
                                    previewingProduct.attributes[1].attribute
                                  }"`
                                : localeText("addToCart")
                            }
                            className="p-button p-button-warning text-xl mb-4"
                            icon="pi pi-shopping-cart"
                            disabled={
                              (previewingProduct.productVariations.length > 0 &&
                                ((previewingProduct.attributes.length === 2 &&
                                  !(currentAttribute1Value && currentAttribute2Value)) ||
                                  (previewingProduct.attributes.length === 1 &&
                                    !currentAttribute1Value))) ||
                              previewingProduct.product.amountInStock === 0 ||
                              (currentVariation && currentVariation.amountInStock === 0) ||
                              (previewingProduct.attributes.length > 0 &&
                                previewingProduct.productVariations.length === 0)
                            }
                          />
                        ) : (
                          <Button
                            label={localeText("addToCart")}
                            className="p-button p-button-warning text-xl mb-4"
                            icon="pi pi-shopping-cart"
                          />
                        )}

                        {previewingProduct.attributes.length > 0 &&
                          previewingProduct.productVariations.length === 0 && (
                            <div className="mb-6">
                              <p>{localeText("youMustFirstGenerateVariations")}</p>
                              <span
                                className="cursor-pointer"
                                style={{ fontWeight: "900" }}
                                onClick={() => {
                                  setAssigningProduct(previewingProduct);
                                  setPreviewingProduct(null);
                                }}
                              >
                                {localeText("clickHereToGenerateVariations")}
                              </span>
                            </div>
                          )}

                        {(previewingProduct.product.brand ||
                          previewingProduct.product.type ||
                          previewingProduct.product.gender) && (
                          <ul className="card border-round surface-100 list-none p-2 m-0 mb-6 mt-4">
                            {previewingProduct.product.brand && (
                              <>
                                <li className="my-1">
                                  <hr className="my-1"></hr>
                                  <p className="m-0">
                                    <b>{localeText("brand")}</b>
                                  </p>
                                  {previewingProduct.product.brand.description}
                                  <hr className="my-1"></hr>
                                </li>
                                <li className="mb-1">
                                  <p className="m-0">
                                    <b>{localeText("model")}</b>
                                  </p>
                                  {previewingProduct.product.model}
                                  <hr className="my-1"></hr>
                                </li>
                              </>
                            )}
                            {previewingProduct.product.type && (
                              <li className="my-1">
                                <p className="m-0">
                                  <b>{localeText("type")}</b>
                                </p>
                                {locale === "en" && (
                                  <>{previewingProduct.product.type.descriptionEnglish}</>
                                )}
                                {locale === "it" && (
                                  <>{previewingProduct.product.type.descriptionItalian}</>
                                )}
                                {locale === "pt" && (
                                  <>{previewingProduct.product.type.descriptionPortuguese}</>
                                )}
                                {locale === "es" && (
                                  <>{previewingProduct.product.type.descriptionSpanish}</>
                                )}
                                <hr className="my-1"></hr>
                              </li>
                            )}
                            {previewingProduct.product.gender && (
                              <li className="my-1">
                                <p className="m-0">
                                  <b>{localeText("gender")}</b>
                                </p>
                                {locale === "en" && (
                                  <>{previewingProduct.product.gender.descriptionEnglish}</>
                                )}
                                {locale === "it" && (
                                  <>{previewingProduct.product.gender.descriptionItalian}</>
                                )}
                                {locale === "pt" && (
                                  <>{previewingProduct.product.gender.descriptionPortuguese}</>
                                )}
                                {locale === "es" && (
                                  <>{previewingProduct.product.gender.descriptionSpanish}</>
                                )}
                                <hr className="my-1"></hr>
                              </li>
                            )}
                          </ul>
                        )}

                        {technicalInfo.length > 0 && (
                          <>
                            <p className="font-bold mt-4">{localeText("productTechnicalInfo")}</p>
                            <div className="grid mb-4 lg:w-8">
                              {technicalInfo.map((technicalInfo) => {
                                return (
                                  <div
                                    style={{ display: "contents" }}
                                    key={`techinf${technicalInfo.id}}`}
                                  >
                                    <div className="col-6 border-1 border-left-2 border-300">
                                      <p>{technicalInfo.key}</p>
                                    </div>
                                    <div className="col-6 surface-100 border-1 border-right-2 border-300">
                                      <p>{technicalInfo.value}</p>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {!previewingProduct && !assigningProduct && (
                  <>
                    <h3 className="my-4">{localeText("products")}</h3>
                    <hr />

                    <TabView activeIndex={tableIndex} onTabChange={(e) => setTableIndex(e.index)}>
                      <TabPanel header={localeText("all")}>
                        {props.plan === "Manager" || props.plan === "Seller" ? (
                          <DataTable
                            className="mt-4 mb-6 p-datatable-customers"
                            value={products}
                            paginator
                            responsiveLayout="scroll"
                            loading={loading || loadingPreview || loadingProduct}
                            dataKey="id"
                            filters={filters2}
                            filterDisplay="row"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate={localeText("showingFirstToLast")}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                          >
                            <Column
                              style={{ width: "10%" }}
                              header={localeText("productImage")}
                              body={(rowData) => {
                                return (
                                  <Link to={`/product?id=${rowData.id}`}>
                                    <AdvancedImage
                                      cldImg={cloudinaryInstance
                                        .image(rowData.imageid1)
                                        .format("webp")
                                        .resize(fill().width(600).height(600))}
                                      height={75}
                                      style={{ border: "1px solid #E0E0E0" }}
                                      className="border-round product-thumbnail"
                                    />
                                  </Link>
                                );
                              }}
                            />
                            <Column
                              field="title"
                              header={localeText("title")}
                              filter
                              filterPlaceholder={localeText("searchByTitle")}
                              filters={filters2}
                              filterDisplay="row"
                            />
                            <Column
                              header={localeText("price")}
                              body={(product) => {
                                const price = product?.promotionalPriceUnique
                                  ? product?.promotionalPriceUnique +
                                    PLATFORM_PRODUCT_FEE * product?.promotionalPriceUnique
                                  : product?.priceUnique +
                                    product?.priceUnique * PLATFORM_PRODUCT_FEE;

                                const priceWithFEE =
                                  product?.shippingOption === "FREESENDCLOUD"
                                    ? price + product?.shippingPrice ?? 0
                                    : price;
                                return (
                                  <p>
                                    {product.currency} {formatPrice(priceWithFEE)}
                                  </p>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productState")}
                              style={{ width: "10%" }}
                              body={(rowData) => {
                                return (
                                  <>
                                    {rowData.stateofproduct === "NEW" && (
                                      <span>{localeText("new")}</span>
                                    )}
                                    {rowData.stateofproduct === "USED" && (
                                      <span>{localeText("used")}</span>
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productStatus")}
                              body={(rowData) => {
                                return <SituationColumn status={rowData.status} />;
                              }}
                            />
                            <Column field="amountInStock" header={localeText("stock")} />
                            <Column
                              header={localeText("manageVariationsShort")}
                              body={(rowData) => {
                                return (
                                  <>
                                    {!rowData.downloadable && (
                                      <Button
                                        icon="pi pi-cog"
                                        onClick={() => getProductById(rowData.id, false)}
                                        className="p-button p-button-rounded"
                                        style={{ textSize: "4em" }}
                                      />
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("preview")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-eye"
                                    onClick={() => {
                                      setImagesVariation([]);
                                      getProductById(rowData.id, true);
                                    }}
                                    className="p-button-help p-button-rounded"
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("edit")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-pencil"
                                    className="p-button-warning p-button-rounded"
                                    onClick={() => editingProduct(rowData.id)}
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("archived")}
                              body={(rowData) => {
                                return (
                                  <div className="flex justify-content-center">
                                    <Button
                                      icon="pi pi-inbox"
                                      className="p-button-secondary p-button-rounded"
                                      onClick={() => modifyStatus(rowData.id, "DELETED")}
                                      style={{ textSize: "4em" }}
                                    />
                                  </div>
                                );
                              }}
                            />
                            <Column
                              header={localeText("visibility")}
                              body={(rowData) => {
                                return (
                                  <VisibilityColumn
                                    status={rowData.status}
                                    onClickPublished={() => modifyStatus(rowData.id, "PUBLISHED")}
                                    onClickUnpublished={() =>
                                      modifyStatus(rowData.id, "UNPUBLISHED")
                                    }
                                  />
                                );
                              }}
                            />
                          </DataTable>
                        ) : (
                          <DataTable
                            className="mt-4 mb-6"
                            value={products}
                            paginator
                            responsiveLayout="scroll"
                            loading={loading || loadingPreview || loadingProduct}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate={localeText("showingFirstToLast")}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                          >
                            <Column
                              style={{ width: "10%" }}
                              header={localeText("productImage")}
                              body={(rowData) => {
                                return (
                                  <Link to={`/product?id=${rowData.id}`}>
                                    <AdvancedImage
                                      cldImg={cloudinaryInstance
                                        .image(rowData.imageid1)
                                        .format("webp")
                                        .resize(fill().width(600).height(600))}
                                      height={75}
                                      style={{ border: "1px solid #E0E0E0" }}
                                      className="border-round product-thumbnail"
                                    />
                                  </Link>
                                );
                              }}
                            />
                            <Column field="title" header={localeText("title")} />
                            <Column
                              header={localeText("price")}
                              body={(product) => {
                                const price = product?.promotionalPriceUnique
                                  ? product?.promotionalPriceUnique +
                                    PLATFORM_PRODUCT_FEE * product?.promotionalPriceUnique
                                  : product?.priceUnique +
                                    product?.priceUnique * PLATFORM_PRODUCT_FEE;

                                const priceWithFEE =
                                  product?.shippingOption === "FREESENDCLOUD"
                                    ? price + product?.shippingPrice ?? 0
                                    : price;

                                return (
                                  <span>
                                    {product.currency} {formatPrice(priceWithFEE)}
                                  </span>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productState")}
                              body={(rowData) => {
                                return (
                                  <>
                                    {rowData.stateofproduct === "NEW" && (
                                      <span>{localeText("new")}</span>
                                    )}
                                    {rowData.stateofproduct === "USED" && (
                                      <span>{localeText("used")}</span>
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productStatus")}
                              body={(rowData) => {
                                return <SituationColumn status={rowData.status} />;
                              }}
                            />
                            <Column
                              header={localeText("preview")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-eye"
                                    onClick={() => {
                                      setImagesVariation([]);
                                      getProductById(rowData.id, true);
                                    }}
                                    className="p-button-help p-button-rounded"
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("edit")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-pencil"
                                    className="p-button-warning p-button-rounded"
                                    onClick={() => editingProduct(rowData.id)}
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("visibility")}
                              body={(rowData) => {
                                return (
                                  <VisibilityColumn
                                    status={rowData.status}
                                    onClickPublished={() => modifyStatus(rowData.id, "PUBLISHED")}
                                    onClickUnpublished={() =>
                                      modifyStatus(rowData.id, "UNPUBLISHED")
                                    }
                                  />
                                );
                              }}
                            />
                          </DataTable>
                        )}
                      </TabPanel>

                      <TabPanel header={localeText("published")}>
                        {props.plan === "Manager" || props.plan === "Seller" ? (
                          <DataTable
                            className="mt-4 mb-6 p-datatable-customers"
                            value={publishedProducts}
                            paginator
                            responsiveLayout="scroll"
                            loading={loading || loadingPreview || loadingProduct}
                            dataKey="id"
                            filters={filters2}
                            filterDisplay="row"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate={localeText("showingFirstToLast")}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                          >
                            <Column
                              style={{ width: "10%" }}
                              header={localeText("productImage")}
                              body={(rowData) => {
                                return (
                                  <Link to={`/product?id=${rowData.id}`}>
                                    <AdvancedImage
                                      cldImg={cloudinaryInstance
                                        .image(rowData.imageid1)
                                        .format("webp")
                                        .resize(fill().width(600).height(600))}
                                      height={75}
                                      style={{ border: "1px solid #E0E0E0" }}
                                      className="border-round product-thumbnail"
                                    />
                                  </Link>
                                );
                              }}
                            />
                            <Column
                              field="title"
                              header={localeText("title")}
                              filter
                              filterPlaceholder={localeText("searchByTitle")}
                              filters={filters2}
                              filterDisplay="row"
                            />
                            <Column
                              header={localeText("price")}
                              body={(product) => {
                                const price = product?.promotionalPriceUnique
                                  ? product?.promotionalPriceUnique +
                                    PLATFORM_PRODUCT_FEE * product?.promotionalPriceUnique
                                  : product?.priceUnique +
                                    product?.priceUnique * PLATFORM_PRODUCT_FEE;

                                const priceWithFEE =
                                  product?.shippingOption === "FREESENDCLOUD"
                                    ? price + product?.shippingPrice ?? 0
                                    : price;

                                return (
                                  <p>
                                    {product.currency} {formatPrice(priceWithFEE)}
                                  </p>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productState")}
                              style={{ width: "10%" }}
                              body={(rowData) => {
                                return (
                                  <>
                                    {rowData.stateofproduct === "NEW" && (
                                      <span>{localeText("new")}</span>
                                    )}
                                    {rowData.stateofproduct === "USED" && (
                                      <span>{localeText("used")}</span>
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productStatus")}
                              body={(rowData) => {
                                return <SituationColumn status={rowData.status} />;
                              }}
                            />
                            <Column field="amountInStock" header={localeText("stock")} />
                            <Column
                              header={localeText("manageVariationsShort")}
                              body={(rowData) => {
                                return (
                                  <>
                                    {!rowData.downloadable && (
                                      <Button
                                        icon="pi pi-cog"
                                        onClick={() => getProductById(rowData.id, false)}
                                        className="p-button p-button-rounded"
                                        style={{ textSize: "4em" }}
                                      />
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("preview")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-eye"
                                    onClick={() => {
                                      setImagesVariation([]);
                                      getProductById(rowData.id, true);
                                    }}
                                    className="p-button-help p-button-rounded"
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("edit")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-pencil"
                                    className="p-button-warning p-button-rounded"
                                    onClick={() => editingProduct(rowData.id)}
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("archived")}
                              body={(rowData) => {
                                return (
                                  <div className="flex justify-content-center">
                                    <Button
                                      icon="pi pi-inbox"
                                      className="p-button-secondary p-button-rounded"
                                      onClick={() => modifyStatus(rowData.id, "DELETED")}
                                      style={{ textSize: "4em" }}
                                    />
                                  </div>
                                );
                              }}
                            />
                            <Column
                              header={localeText("visibility")}
                              body={(rowData) => {
                                return (
                                  <VisibilityColumn
                                    status={rowData.status}
                                    onClickPublished={() => modifyStatus(rowData.id, "PUBLISHED")}
                                    onClickUnpublished={() =>
                                      modifyStatus(rowData.id, "UNPUBLISHED")
                                    }
                                  />
                                );
                              }}
                            />
                          </DataTable>
                        ) : (
                          <DataTable
                            className="mt-4 mb-6"
                            value={publishedProducts}
                            paginator
                            responsiveLayout="scroll"
                            loading={loading || loadingPreview || loadingProduct}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate={localeText("showingFirstToLast")}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                          >
                            <Column
                              style={{ width: "10%" }}
                              header={localeText("productImage")}
                              body={(rowData) => {
                                return (
                                  <Link to={`/product?id=${rowData.id}`}>
                                    <AdvancedImage
                                      cldImg={cloudinaryInstance
                                        .image(rowData.imageid1)
                                        .format("webp")
                                        .resize(fill().width(600).height(600))}
                                      height={75}
                                      style={{ border: "1px solid #E0E0E0" }}
                                      className="border-round product-thumbnail"
                                    />
                                  </Link>
                                );
                              }}
                            />
                            <Column field="title" header={localeText("title")} />
                            <Column
                              header={localeText("price")}
                              body={(product) => {
                                const price = product?.promotionalPriceUnique
                                  ? product?.promotionalPriceUnique +
                                    PLATFORM_PRODUCT_FEE * product?.promotionalPriceUnique
                                  : product?.priceUnique +
                                    product?.priceUnique * PLATFORM_PRODUCT_FEE;

                                const priceWithFEE =
                                  product?.shippingOption === "FREESENDCLOUD"
                                    ? price + product?.shippingPrice ?? 0
                                    : price;

                                return (
                                  <p>
                                    {product.currency} {formatPrice(priceWithFEE)}
                                  </p>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productState")}
                              body={(rowData) => {
                                return (
                                  <>
                                    {rowData.stateofproduct === "NEW" && (
                                      <span>{localeText("new")}</span>
                                    )}
                                    {rowData.stateofproduct === "USED" && (
                                      <span>{localeText("used")}</span>
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productStatus")}
                              body={(rowData) => {
                                return <SituationColumn status={rowData.status} />;
                              }}
                            />
                            <Column
                              header={localeText("preview")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-eye"
                                    onClick={() => {
                                      setImagesVariation([]);
                                      getProductById(rowData.id, true);
                                    }}
                                    className="p-button-help p-button-rounded"
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("edit")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-pencil"
                                    className="p-button-warning p-button-rounded"
                                    onClick={() => editingProduct(rowData.id)}
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("visibility")}
                              body={(rowData) => {
                                return (
                                  <VisibilityColumn
                                    status={rowData.status}
                                    onClickPublished={() => modifyStatus(rowData.id, "PUBLISHED")}
                                    onClickUnpublished={() =>
                                      modifyStatus(rowData.id, "UNPUBLISHED")
                                    }
                                  />
                                );
                              }}
                            />
                          </DataTable>
                        )}
                      </TabPanel>

                      <TabPanel header={localeText("unpublished")}>
                        {props.plan === "Manager" || props.plan === "Seller" ? (
                          <DataTable
                            className="mt-4 mb-6 p-datatable-customers"
                            value={unpublishedProducts}
                            paginator
                            responsiveLayout="scroll"
                            loading={loading || loadingPreview || loadingProduct}
                            dataKey="id"
                            filters={filters2}
                            filterDisplay="row"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate={localeText("showingFirstToLast")}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                          >
                            <Column
                              style={{ width: "10%" }}
                              header={localeText("productImage")}
                              body={(rowData) => {
                                return (
                                  <Link to={`/product?id=${rowData.id}`}>
                                    <AdvancedImage
                                      cldImg={cloudinaryInstance
                                        .image(rowData.imageid1)
                                        .format("webp")
                                        .resize(fill().width(600).height(600))}
                                      height={75}
                                      style={{ border: "1px solid #E0E0E0" }}
                                      className="border-round product-thumbnail"
                                    />
                                  </Link>
                                );
                              }}
                            />
                            <Column
                              field="title"
                              header={localeText("title")}
                              filter
                              filterPlaceholder={localeText("searchByTitle")}
                              filters={filters2}
                              filterDisplay="row"
                            />
                            <Column
                              header={localeText("price")}
                              body={(product) => {
                                const price = product?.promotionalPriceUnique
                                  ? product?.promotionalPriceUnique +
                                    PLATFORM_PRODUCT_FEE * product?.promotionalPriceUnique
                                  : product?.priceUnique +
                                    product?.priceUnique * PLATFORM_PRODUCT_FEE;

                                const priceWithFEE =
                                  product?.shippingOption === "FREESENDCLOUD"
                                    ? price + product?.shippingPrice ?? 0
                                    : price;

                                return (
                                  <p>
                                    {product.currency} {formatPrice(priceWithFEE)}
                                  </p>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productState")}
                              style={{ width: "10%" }}
                              body={(rowData) => {
                                return (
                                  <>
                                    {rowData.stateofproduct === "NEW" && (
                                      <span>{localeText("new")}</span>
                                    )}
                                    {rowData.stateofproduct === "USED" && (
                                      <span>{localeText("used")}</span>
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productStatus")}
                              body={(rowData) => {
                                return <SituationColumn status={rowData.status} />;
                              }}
                            />
                            <Column field="amountInStock" header={localeText("stock")} />
                            <Column
                              header={localeText("manageVariationsShort")}
                              body={(rowData) => {
                                return (
                                  <>
                                    {!rowData.downloadable && (
                                      <Button
                                        icon="pi pi-cog"
                                        onClick={() => getProductById(rowData.id, false)}
                                        className="p-button p-button-rounded"
                                        style={{ textSize: "4em" }}
                                      />
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("preview")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-eye"
                                    onClick={() => {
                                      setImagesVariation([]);
                                      getProductById(rowData.id, true);
                                    }}
                                    className="p-button-help p-button-rounded"
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("edit")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-pencil"
                                    className="p-button-warning p-button-rounded"
                                    onClick={() => editingProduct(rowData.id)}
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("archived")}
                              body={(rowData) => {
                                return (
                                  <div className="flex justify-content-center">
                                    <Button
                                      icon="pi pi-inbox"
                                      className="p-button-secondary p-button-rounded"
                                      onClick={() => modifyStatus(rowData.id, "DELETED")}
                                      style={{ textSize: "4em" }}
                                    />
                                  </div>
                                );
                              }}
                            />
                            <Column
                              header={localeText("visibility")}
                              body={(rowData) => {
                                return (
                                  <VisibilityColumn
                                    status={rowData.status}
                                    onClickPublished={() => modifyStatus(rowData.id, "PUBLISHED")}
                                    onClickUnpublished={() =>
                                      modifyStatus(rowData.id, "UNPUBLISHED")
                                    }
                                  />
                                );
                              }}
                            />
                          </DataTable>
                        ) : (
                          <DataTable
                            className="mt-4 mb-6"
                            value={unpublishedProducts}
                            paginator
                            responsiveLayout="scroll"
                            loading={loading || loadingPreview || loadingProduct}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate={localeText("showingFirstToLast")}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                          >
                            <Column
                              style={{ width: "10%" }}
                              header={localeText("productImage")}
                              body={(rowData) => {
                                return (
                                  <Link to={`/product?id=${rowData.id}`}>
                                    <AdvancedImage
                                      cldImg={cloudinaryInstance
                                        .image(rowData.imageid1)
                                        .format("webp")
                                        .resize(fill().width(600).height(600))}
                                      height={75}
                                      style={{ border: "1px solid #E0E0E0" }}
                                      className="border-round product-thumbnail"
                                    />
                                  </Link>
                                );
                              }}
                            />
                            <Column field="title" header={localeText("title")} />
                            <Column
                              header={localeText("price")}
                              body={(product) => {
                                const price = product?.promotionalPriceUnique
                                  ? product?.promotionalPriceUnique +
                                    PLATFORM_PRODUCT_FEE * product?.promotionalPriceUnique
                                  : product?.priceUnique +
                                    product?.priceUnique * PLATFORM_PRODUCT_FEE;

                                const priceWithFEE =
                                  product?.shippingOption === "FREESENDCLOUD"
                                    ? price + product?.shippingPrice ?? 0
                                    : price;

                                return (
                                  <p>
                                    {product.currency} {formatPrice(priceWithFEE)}
                                  </p>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productState")}
                              body={(rowData) => {
                                return (
                                  <>
                                    {rowData.stateofproduct === "NEW" && (
                                      <span>{localeText("new")}</span>
                                    )}
                                    {rowData.stateofproduct === "USED" && (
                                      <span>{localeText("used")}</span>
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productStatus")}
                              body={(rowData) => {
                                return <SituationColumn status={rowData.status} />;
                              }}
                            />
                            <Column
                              header={localeText("preview")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-eye"
                                    onClick={() => {
                                      setImagesVariation([]);
                                      getProductById(rowData.id, true);
                                    }}
                                    className="p-button-help p-button-rounded"
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("edit")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-pencil"
                                    className="p-button-warning p-button-rounded"
                                    onClick={() => editingProduct(rowData.id)}
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("visibility")}
                              body={(rowData) => {
                                return (
                                  <VisibilityColumn
                                    status={rowData.status}
                                    onClickPublished={() => modifyStatus(rowData.id, "PUBLISHED")}
                                    onClickUnpublished={() =>
                                      modifyStatus(rowData.id, "UNPUBLISHED")
                                    }
                                  />
                                );
                              }}
                            />
                          </DataTable>
                        )}
                      </TabPanel>

                      <TabPanel header={localeText("imported")}>
                        {props.plan === "Manager" || props.plan === "Seller" ? (
                          <DataTable
                            className="mt-4 mb-6 p-datatable-customers"
                            value={importedProducts}
                            paginator
                            responsiveLayout="scroll"
                            loading={loading || loadingPreview || loadingProduct}
                            dataKey="id"
                            filters={filters2}
                            filterDisplay="row"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate={localeText("showingFirstToLast")}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                          >
                            <Column
                              style={{ width: "10%" }}
                              header={localeText("productImage")}
                              body={(product) => {
                                return (
                                  <Link to={`/product?id=${product.id}`}>
                                    <AdvancedImage
                                      cldImg={cloudinaryInstance
                                        .image(product.imageid1)
                                        .format("webp")
                                        .resize(fill().width(600).height(600))}
                                      height={75}
                                      style={{ border: "1px solid #E0E0E0" }}
                                      className="border-round product-thumbnail"
                                    />
                                  </Link>
                                );
                              }}
                            />
                            <Column
                              field="title"
                              header={localeText("title")}
                              filter
                              filterPlaceholder={localeText("searchByTitle")}
                              filters={filters2}
                              filterDisplay="row"
                            />
                            <Column
                              header={localeText("price")}
                              body={(product) => {
                                const price = product?.promotionalPriceUnique
                                  ? product?.promotionalPriceUnique +
                                    PLATFORM_PRODUCT_FEE * product?.promotionalPriceUnique
                                  : product?.priceUnique +
                                    product?.priceUnique * PLATFORM_PRODUCT_FEE;

                                const priceWithFEE =
                                  product?.shippingOption === "FREESENDCLOUD"
                                    ? price + product?.shippingPrice ?? 0
                                    : price;

                                return (
                                  <p>
                                    {product.currency} {formatPrice(priceWithFEE)}
                                  </p>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productState")}
                              style={{ width: "10%" }}
                              body={(rowData) => {
                                return (
                                  <>
                                    {rowData.stateofproduct === "NEW" && (
                                      <span>{localeText("new")}</span>
                                    )}
                                    {rowData.stateofproduct === "USED" && (
                                      <span>{localeText("used")}</span>
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productStatus")}
                              body={(rowData) => {
                                return <SituationColumn status={rowData.status} />;
                              }}
                            />
                            <Column
                              field="originProductImported"
                              header={localeText("importOrigin")}
                              sortable
                            />
                            <Column field="amountInStock" header={localeText("stock")} />
                            {(props.plan === "Manager" || props.plan === "Seller") && (
                              <Column
                                header={localeText("manageVariationsShort")}
                                body={(rowData) => {
                                  return (
                                    <>
                                      {!rowData.downloadable && (
                                        <Button
                                          icon="pi pi-cog"
                                          onClick={() => getProductById(rowData.id, false)}
                                          className="p-button p-button-rounded"
                                          style={{ textSize: "4em" }}
                                        />
                                      )}
                                    </>
                                  );
                                }}
                              />
                            )}
                            <Column
                              header={localeText("preview")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-eye"
                                    onClick={() => {
                                      setImagesVariation([]);
                                      getProductById(rowData.id, true);
                                    }}
                                    className="p-button-help p-button-rounded"
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("edit")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-pencil"
                                    className="p-button-warning p-button-rounded"
                                    onClick={() => editingProduct(rowData.id)}
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("visibility")}
                              body={(rowData) => {
                                return (
                                  <VisibilityColumn
                                    status={rowData.status}
                                    onClickPublished={() => modifyStatus(rowData.id, "PUBLISHED")}
                                    onClickUnpublished={() =>
                                      modifyStatus(rowData.id, "UNPUBLISHED")
                                    }
                                  />
                                );
                              }}
                            />
                          </DataTable>
                        ) : (
                          <div className="text-center">
                            <i className="pi pi-lock text-8xl text-400 my-4"></i>
                            <h2 className="my-6">{localeText("planNotAllowed")}</h2>
                          </div>
                        )}
                      </TabPanel>

                      <TabPanel header={localeText("archivedProduct")}>
                        {props.plan === "Manager" || props.plan === "Seller" ? (
                          <DataTable
                            className="mt-4 mb-6 p-datatable-customers"
                            value={archivedProducts}
                            paginator
                            responsiveLayout="scroll"
                            loading={loading || loadingPreview || loadingProduct}
                            dataKey="id"
                            filters={filters2}
                            filterDisplay="row"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate={localeText("showingFirstToLast")}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                          >
                            <Column
                              style={{ width: "10%" }}
                              header={localeText("productImage")}
                              body={(rowData) => {
                                return (
                                  <Link to={`/product?id=${rowData.id}`}>
                                    <AdvancedImage
                                      cldImg={cloudinaryInstance
                                        .image(rowData.imageid1)
                                        .format("webp")
                                        .resize(fill().width(600).height(600))}
                                      height={75}
                                      style={{ border: "1px solid #E0E0E0" }}
                                      className="border-round product-thumbnail"
                                    />
                                  </Link>
                                );
                              }}
                            />
                            <Column
                              field="title"
                              header={localeText("title")}
                              filter
                              filterPlaceholder={localeText("searchByTitle")}
                              filters={filters2}
                              filterDisplay="row"
                            />
                            <Column
                              header={localeText("price")}
                              body={(product) => {
                                const price = product?.promotionalPriceUnique
                                  ? product?.promotionalPriceUnique +
                                    PLATFORM_PRODUCT_FEE * product?.promotionalPriceUnique
                                  : product?.priceUnique +
                                    product?.priceUnique * PLATFORM_PRODUCT_FEE;

                                const priceWithFEE =
                                  product?.shippingOption === "FREESENDCLOUD"
                                    ? price + product?.shippingPrice ?? 0
                                    : price;
                                return (
                                  <p>
                                    {product.currency} {formatPrice(priceWithFEE)}
                                  </p>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productState")}
                              style={{ width: "10%" }}
                              body={(rowData) => {
                                return (
                                  <>
                                    {rowData.stateofproduct === "NEW" && (
                                      <span>{localeText("new")}</span>
                                    )}
                                    {rowData.stateofproduct === "USED" && (
                                      <span>{localeText("used")}</span>
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productStatus")}
                              body={(rowData) => {
                                return <SituationColumn status={rowData.status} />;
                              }}
                            />
                            <Column field="amountInStock" header={localeText("stock")} />

                            <Column
                              header={localeText("preview")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-eye"
                                    onClick={() => {
                                      setImagesVariation([]);
                                      getProductById(rowData.id, true);
                                    }}
                                    className="p-button-help p-button-rounded"
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />

                            <Column
                              header={<p className="text-center block">{localeText("publish")}</p>}
                              body={(rowData) => {
                                return (
                                  <VisibilityColumn
                                    status={rowData.status}
                                    onClickPublished={() => modifyStatus(rowData.id, "PUBLISHED")}
                                    onClickUnpublished={() =>
                                      modifyStatus(rowData.id, "UNPUBLISHED")
                                    }
                                  />
                                );
                              }}
                            />
                          </DataTable>
                        ) : (
                          <DataTable
                            className="mt-4 mb-6"
                            value={products}
                            paginator
                            responsiveLayout="scroll"
                            loading={loading || loadingPreview || loadingProduct}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate={localeText("showingFirstToLast")}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                          >
                            <Column
                              style={{ width: "10%" }}
                              header={localeText("productImage")}
                              body={(rowData) => {
                                return (
                                  <Link to={`/product?id=${rowData.id}`}>
                                    <AdvancedImage
                                      cldImg={cloudinaryInstance
                                        .image(rowData.imageid1)
                                        .format("webp")
                                        .resize(fill().width(600).height(600))}
                                      height={75}
                                      style={{ border: "1px solid #E0E0E0" }}
                                      className="border-round product-thumbnail"
                                    />
                                  </Link>
                                );
                              }}
                            />
                            <Column field="title" header={localeText("title")} />
                            <Column
                              header={localeText("price")}
                              body={(product) => {
                                const price = product?.promotionalPriceUnique
                                  ? product?.promotionalPriceUnique +
                                    PLATFORM_PRODUCT_FEE * product?.promotionalPriceUnique
                                  : product?.priceUnique +
                                    product?.priceUnique * PLATFORM_PRODUCT_FEE;

                                const priceWithFEE =
                                  product?.shippingOption === "FREESENDCLOUD"
                                    ? price + product?.shippingPrice ?? 0
                                    : price;

                                return (
                                  <span>
                                    {product.currency} {formatPrice(priceWithFEE)}
                                  </span>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productState")}
                              body={(rowData) => {
                                return (
                                  <>
                                    {rowData.stateofproduct === "NEW" && (
                                      <span>{localeText("new")}</span>
                                    )}
                                    {rowData.stateofproduct === "USED" && (
                                      <span>{localeText("used")}</span>
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column
                              header={localeText("productStatus")}
                              body={(rowData) => {
                                return <SituationColumn status={rowData.status} />;
                              }}
                            />
                            <Column
                              header={localeText("preview")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-eye"
                                    onClick={() => {
                                      setImagesVariation([]);
                                      getProductById(rowData.id, true);
                                    }}
                                    className="p-button-help p-button-rounded"
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("edit")}
                              body={(rowData) => {
                                return (
                                  <Button
                                    icon="pi pi-pencil"
                                    className="p-button-warning p-button-rounded"
                                    onClick={() => editingProduct(rowData.id)}
                                    style={{ textSize: "4em" }}
                                  />
                                );
                              }}
                            />
                            <Column
                              header={localeText("visibility")}
                              body={(rowData) => {
                                return (
                                  <VisibilityColumn
                                    status={rowData.status}
                                    onClickPublished={() => modifyStatus(rowData.id, "PUBLISHED")}
                                    onClickUnpublished={() =>
                                      modifyStatus(rowData.id, "UNPUBLISHED")
                                    }
                                  />
                                );
                              }}
                            />
                          </DataTable>
                        )}
                      </TabPanel>
                    </TabView>
                  </>
                )}
              </>
            ) : (
              <EditingProduct
                product={editingProductObj}
                setRetryFetchProducts={setRetryFetchProducts}
                currency={props.currency}
                userInfo={props.userInfo}
                plan={props.plan}
                setEditingProductObj={setEditingProductObj}
                getProductById={getProductById}
              />
            )}
          </>
        )}
        {props.plan === "Promoter" && (
          <div className="text-center">
            <i className="pi pi-lock text-8xl text-400 my-4"></i>
            <h2 className="my-6">{localeText("planNotAllowed")}</h2>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductsList;
